import { render, staticRenderFns } from "./KompetenzrasterModal.vue?vue&type=template&id=34fa9612&"
import script from "./KompetenzrasterModal.vue?vue&type=script&lang=js&"
export * from "./KompetenzrasterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports